import { Component, input, output, computed, inject } from '@angular/core';
import { select } from '@ngxs/store';
import { InventoryManagementState } from 'remarketing-angular-library';
import { translateSignal } from '@jsverse/transloco';
import { SearchFilterComponent } from '../search-filter.component';
import {
  DateRangeComponent,
} from '../../date-range/date-range.component';

import { SaComponent } from 'smartauction-frontend-micro-library';

@Component({
  selector: 'app-mobile-search-filter',
  templateUrl: './mobile-search-filter.component.html',
  styleUrls: ['./mobile-search-filter.component.scss'],
  imports: [SearchFilterComponent, DateRangeComponent]
})
export class MobileSearchFilterComponent extends SaComponent {
  public showDateRange = input<boolean>(false);
  public closed = output<void>();

  private readonly inventoryManagementSearchResponse$ = select(InventoryManagementState.searchResponse);

  protected readonly resultsString$ = computed(() => {
    const count = this.inventoryManagementSearchResponse$()?.totalItems;
    if (count === 0 || count > 1) {
      return `${count} Results`;
    } else if (count === 1) {
      return '1 Result';
    } else {
      return '';
    }
  });

  protected readonly count$ = computed(() => {
    const totalItems = this.inventoryManagementSearchResponse$()?.totalItems;
    return totalItems ? totalItems : 0;
  });

  protected readonly textResults$ = translateSignal('sellModule.manageInventory.mobileSearchFilter.textBack', {
    count: this.count$()
  });

  constructor() {
    super();
  }

  backClicked() {
    this.closed.emit();
  }
}
